import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const filterFields = [
  {
    section: "Filtros para o relatório",
    fields: [
      createField({
        id: "filter.period",
        label: "Data de produção",
        placeholder: "Selecione a data de produção",
        type: "date",
        icon: faCalendar,
        fullWidth: true,
      }),
    ],
  },
];
